import { render, staticRenderFns } from "./BriqColorInput.vue?vue&type=template&id=1a379568&scoped=true&lang=pug&"
import script from "./BriqColorInput.vue?vue&type=script&lang=js&"
export * from "./BriqColorInput.vue?vue&type=script&lang=js&"
import style0 from "./BriqColorInput.vue?vue&type=style&index=0&id=1a379568&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a379568",
  null
  
)

export default component.exports